import './Mulligan.css';
import {useTypedSelector} from "../../../hooks/useTypedSelector";
import {useActions} from "../../../hooks/useActions";
import {useEffect} from "react";

function Mulligan() {
    const {isLoading, user} = useTypedSelector(state => state.auth);
    const {playerTurn, playerMulligan, phase} = useTypedSelector(state => state.game);

    const {setPlayerMulligan, makeMilligan} = useActions();

    let rootClasses = 'muContainer';


    if (user.level >= 3 && phase === 'play_card' && playerTurn === 1 && !playerMulligan) {
        rootClasses += ' muMulliganActive';
    }

    useEffect(() => {
        if (user.level < 3 && !playerMulligan) {
            setPlayerMulligan(true);
        }
    }, [user.level, playerMulligan, setPlayerMulligan]);

    return (
        <div className={rootClasses}>
            <div className={'muButtonContainer'}>
                <div className={'muYesButton'} onClick={async () => {
                    if (isLoading) {
                        return;
                    }
                    await makeMilligan();

                    setPlayerMulligan(true);

                }}></div>
                <div className={'muNoButton'} onClick={() => {
                    if (isLoading) {
                        return;
                    }
                    setPlayerMulligan(true);
                }}></div>
            </div>
        </div>
    )
}

export default Mulligan;